<style>
  .whiteSpace {
    background-color: white;
    height: 72px;
    width: 100%;
  }
</style>

<div class="whiteSpace" />
